<template lang="pug">
	div.container-fluid
		.row
			.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
				.card
					.card-header.bg-info.text-white
						span.fa.fa-search.mr-2
						| Buscador de programas
					.card-body
						.form-group
							label Emisora
							select.form-control(v-model="filtro.emisora_ID", @change="buscar")
								option(:value="null") Selecciona
								option(
									:value="emisora.ID_emisora"
									:key="emisora.ID_emisora"
									v-for="emisora in listadoEmisoras"
								) {{emisora.nombre}}
						.form-group
							label Día
							datepicker(
								:inline="true"
								:language="$dateLang"
								:monday-first="true"
								v-model="filtro.dia",
								@input="buscar"
							)
					.card-footer
						button.btn.btn-primary.m-1(@click="buscar")
							span.fa.fa-search.mr-2
							| Buscar
						button.btn.btn-warning.m-1(@click="nuevo")
							span.fa.fa-plus.mr-2
							| Nuevo
			.col-xs-12.col-sm-12.col-md-6.col-lg-9.col-xl-9
				.card
					.card-header
						span.fa.fa-list.mr-2
						| Resultados
					.table-responsive
						table.table.table-striped.mb-0
							thead.bg-dark.text-white
								tr
									th ID
									th Emisora
									th Día
									th Hora inicio
									th Hora fin
									th Nombre
									th Bloques
									th Inserciones
							tbody
								tr(v-for="programa in listadoProgramas", :key="programa.ID_programa")
									td.p-1.pl-1(style="vertical-align:middle;") {{programa.ID_programa}}
									td.p-1(style="vertical-align:middle;") {{programa.emisoraNombre}}
									td.p-1(style="vertical-align:middle;") {{programa.dia}}
									td.p-1(style="vertical-align:middle;") {{programa.hora_inicio}}
									td.p-1(style="vertical-align:middle;") {{programa.hora_fin}}
									td.p-1(style="vertical-align:middle;") {{programa.nombre}}
									td.p-1(style="vertical-align:middle;") {{programa.bloques}} bloques
									td.p-1(style="vertical-align:middle;") {{programa.lineas}} cuñas


		editor-programas(id-programa=":ID_programa", @cerrar="ID_programa = null", v-if="ID_programa")
</template>

<script>
import axios from 'axios'
import EditorProgramas from './editor-programas.vue'
export default {
	components: {
		'editor-programas': EditorProgramas
	},
	data () {
		return {
			filtro: {
				emisora_ID: null,
				dia: new Date()
			},
			listadoEmisoras: [],
			listadoProgramas: [],
			ID_programa: null
		}
	},
	created () {
		axios.post('gestion-emisoras/php/api/emisoras/buscar-emisoras.php', {activa: true})
			.then(res => {
				this.listadoEmisoras = res.data.listado
			})
			.catch(this.$responseError)
	},
	methods: {
		nuevo () {
			this.ID_programa = 'nuevo'
		},
		buscar () {
			if (!this.filtro.emisora_ID) {
				return
			}
			const datos = {
				emisora_ID: this.filtro.emisora_ID,
				dia: Math.floor(this.filtro.dia.getTime() / 1000)
			}
			axios.post('gestion-emisoras/php/api/programas/buscar-programas.php', datos)
				.then(res => {
					this.listadoProgramas = res.data.listado
				})
				.catch(this.$responseError)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/programas/programas.vue